import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";
import { Science, TouchApp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import CustomTextField from "../Custom/CustomTextField";
import CustomButton from "../Custom/CustomButton";

const SoilTestForm = ({
  testMode,
  fields,
  formData,
  errors,
  onChange,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          {testMode === "device" ? (
            <>
              <Science color="primary" sx={{ mr: 2 }} />
              <Box>
                <Typography variant="h6">
                  {t("Device-Based Testing")}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t("Automated soil analysis using connected devices")}
                </Typography>
              </Box>
            </>
          ) : (
            <>
              <TouchApp color="primary" sx={{ mr: 2 }} />
              <Box>
                <Typography variant="h6">{t("Manual Testing")}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {t("Enter soil test results manually")}
                </Typography>
              </Box>
            </>
          )}
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={2}>
          {fields.map((field) => (
            <Grid
              item
              xs={12}
              sm={field.type === "select" ? 6 : 12}
              key={field.name}
            >
              <CustomTextField
                label={field.label}
                name={field.name}
                value={formData[field.name] || ""}
                onChange={onChange}
                type={field.type}
                options={field.options}
                error={errors[field.name]}
                helperText={errors[field.name]}
                required={field.required}
                placeholder={field.placeholder}
                fullWidth
              />
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
          <CustomButton onClick={onSubmit}>
            {testMode === "device" ? (
              <>
                <Science sx={{ mr: 1 }} />
                {t("Create Device Test")}
              </>
            ) : (
              <>
                <TouchApp sx={{ mr: 1 }} />
                {t("Create Manual Test")}
              </>
            )}
          </CustomButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SoilTestForm;
